import { useEffect } from "react";
import Grid from "@mui/material/Grid";

// PorterIQ Dashboard React components
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";

// PorterIQ Dashboard React example components
import DashboardLayout from "components/layout/DashboardLayout";
import DashboardNavbar from "components/navigation/DashboardNavbar";

// Analytics context
import { useAnalytics } from "context/AnalyticsContext";

// Icon for page title
import { IoStatsChart } from "react-icons/io5";

// Product Insights specific components
import ProductMentionVolumeChart from "./components/ProductMentionVolumeChart";
import TopMentionedProducts from "./components/TopMentionedProducts";
import ProductInsightsStats from "./components/ProductInsightsStats";
import ProductMentionsTable from "./components/ProductMentionsTable";

// Data hooks
import useProductAnalyticsData from "./data/useProductAnalyticsData";

// Service for tracking page views
import { analyticsService } from "services/trackingService";

// AI Feature Components
import QuickCatchup from "components/QuickCatchup";
import useEntityName from "hooks/useEntityName";

function ProductInsightsPage() {
  const { selectedCompetitor, selectedPresetKey } = useAnalytics();
  const competitorDisplayName = useEntityName("competitor", selectedCompetitor);

  const {
    trendsData,
    topProductsData,
    loading: analyticsLoading,
    error: analyticsError,
  } = useProductAnalyticsData(selectedCompetitor, selectedPresetKey);

  useEffect(() => {
    if (selectedPresetKey) {
      analyticsService.trackPageView("PRODUCT_INSIGHTS", {
        companyId: selectedCompetitor,
        presetKey: selectedPresetKey,
      });
    }
  }, [selectedCompetitor, selectedPresetKey]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <QuickCatchup source="products" competitorId={selectedCompetitor} />
      <VuiBox py={3}>
        <VuiBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
          <VuiBox display="flex" alignItems="center">
            <IoStatsChart size="24px" color="#0075ff" />
            <VuiTypography variant="h6" color="white" fontWeight="medium" ml={1.5} sx={{ fontSize: "1rem" }}>
              Product Insights
            </VuiTypography>
          </VuiBox>
        </VuiBox>

        {/* Product Insights Statistics Cards */}
        <ProductInsightsStats topProductsData={topProductsData} loading={analyticsLoading} />

        {/* Product Mention Volume Chart */}
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <ProductMentionVolumeChart
                trendsData={trendsData}
                loading={analyticsLoading}
                error={analyticsError}
                competitorName={competitorDisplayName}
              />
            </Grid>
          </Grid>
        </VuiBox>

        {/* Top Mentioned Products Chart */}
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <TopMentionedProducts
                topProductsData={topProductsData}
                loading={analyticsLoading}
                error={analyticsError}
                competitorName={competitorDisplayName}
              />
            </Grid>
          </Grid>
        </VuiBox>

        {/* Product Mentions Table - Full Width */}
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <ProductMentionsTable />
            </Grid>
          </Grid>
        </VuiBox>

      </VuiBox>
    </DashboardLayout>
  );
}

export default ProductInsightsPage; 